import React from "react";

export default function WorkExperience() {
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="box-shadow-full">
            <h2 style={{ textAlign: "center" }}>WORK EXPERIENCE</h2>
            <br />

            <h3>Software Developer</h3>
            <h5>Lynk Remote Technologies &nbsp; (July 2024 - Present)</h5>
            <br />
            <section>
              <h5>Roles & Responsibilities</h5>
              <ul>  
                <li>
                  Built responsive web apps using HTML, CSS, React.js, JavaScript, Bootstrap enhancing UI/UX performance.
                </li>
                <li>
                  Developed RESTful APIs with Node.js and Express.js for frontend-backend integration.
                </li>
                <li>
                  Worked with SQL for data modeling, queries, and indexing.
                </li>
                <li>
                  Used Redux efficient state management in React apps.
                </li>
                <li>
                  Created modular, reusable components using modern JavaScript (ES6+).
                </li>
                <li>
                  Collaborated in Agile sprints to deliver full-stack features end-to-end.
                </li>
                <li>
                  Wrote unit and integration tests to ensure code reliability.
                </li>
                <li>
                  Assisted in deployment and monitoring via CI/CD and cloud tools like AWS.
                </li>
                <li>
                  Efficient in Problem-solving, debugging skills and resolving complex issues.
                </li>
              </ul>
            </section>
            <br />

            <h3>Software Developer</h3>
            <h5>
              Electrical Heat Trace Group Ltd. &nbsp; (Jan 2022 - May 2024)
            </h5>
            <br />
            <section>
              <h5>Roles & Responsibilities</h5>
              <ul>
                <li>
                  Designed and developed full-stack web app using ReactJS and NodeJS.
                </li>
                <li>
                  
Integrated JWT-based user authentication and 3rd party APIs for feature enhancement.
                </li>
                <li>
                    
Enhanced database performance by 30% via optimized PostgreSQL queries.
                </li>
                <li>
                  
Improved app load speed by 25% through Redis caching and frontend optimizations.
                   
                </li>
                <li>
                  
Conducted code reviews and contributed to CI/CD setup with Docker and AWS.
                    
                </li>
                <li>
                  
Tools/Tech: <strong>React, Redux, Redux-Saga, SCSS, Material UI, Victory Charts, Knex, PostgreSQL, AWS, Docker, Webpack,
Formik, Yup, Redis, ESLint, WebSockets, Immutable.js, Git, Github.</strong>
                </li>
                
              </ul>
            </section>

            <br />
            <h3>Web Developer</h3>
            <h5>AceWebx &nbsp; (June 2019 - May 2020)</h5>
            <br />
            <section>
              <h5>Roles & Responsibilities</h5>
              <ul>
                <li>
                  Developed multi-page user experiences in HTML, aligning with
                  project requirements to enhance customer engagement.
                </li>
                <li>
                  Ensured website responsiveness across all devices by
                  implementing media queries, optimizing user experience for
                  diverse screen sizes.
                </li>
                <li>
                  Utilized Bootstrap (v4.4.1) library alongside CSS3 to
                  streamline and scale website styling, maintaining consistency
                  and ease of maintenance.
                </li>
                <li>
                  Employed JavaScript and jQuery to dynamically manipulate user
                  interface elements, enhancing interactivity and user
                  engagement.
                </li>
                <li>
                  Acquired proficiency in key concepts of the Document Object
                  Model (DOM), facilitating efficient manipulation of web page
                  elements.
                </li>
                <li>
                  Implemented and customized embedded iFrames for integrating
                  Google Maps functionality, enhancing website functionality and
                  user experience.
                </li>
                <li>
                  Demonstrated expertise in using GitHub and Git version control
                  systems, ensuring efficient collaboration and effective
                  management of project codebase.
                </li>
              </ul>
            </section>
          </div>
        </div>
      </div>

      <div className="container  pl-0 pr-0">
        <div className="box-shadow-full mb-0">
          <h2 style={{ textAlign: "center" }}>SUMMARY OF SKILLS</h2>
          <br />
          <ul>
            
            <li>
              <strong>Frontend and Backend Expertise:</strong> Well-developed
              knowledge of frontend and backend technologies including React,
              NodeJS, and JavaScript (ES6), ensuring efficient development and
              implementation of features.
            </li>
            <li>
              <strong>Proficiency with MERN Stack:</strong> Demonstrated
              experience with MongoDB, Express, React, and Node, leveraging
              these technologies to build robust and scalable web applications.
            </li>
            <li>
              <strong>Full Stack Development Skills:</strong> Proficient in
              HTML5, CSS3, JavaScript, jQuery, ReactJS, NodeJS, and PHP, adept
              at UI development and creating dynamic web applications.
            </li>
            <li>
              <strong>NPM and Bootstrap:</strong> Understanding and utilization
              of NPM libraries and Bootstrap for efficient development and
              styling of web applications.
            </li>
            <li>
              <strong>RESTful API Development:</strong> Experience in designing
              and implementing RESTful APIs using NodeJS at the backend,
              enabling seamless communication between frontend and backend
              systems.
            </li>
            <li>
              <strong>Responsive and Accessible Web Design:</strong> Proficient
              in designing and developing responsive and user-friendly websites
              with a focus on web accessibility standards, ensuring inclusivity
              for all users.
            </li>
            <li>
              <strong>Debugging and Testing:</strong> Skilled in debugging using
              browser developer tools in Chrome and Firefox, and testing APIs
              with tools like Postman, ensuring the reliability and
              functionality of web applications.
            </li>
            <li>
              <strong>Database Management:</strong> Proficient in MySQL and
              MongoDB, with hands-on experience in database management and
              optimization for efficient data storage and retrieval.
            </li>
            <li>
              <strong>Version Control and Hosting:</strong> Experienced in
              version control using Git and GitHub, and website hosting on
              platforms like Heroku, Firebase, and GoDaddy, ensuring efficient
              collaboration and deployment.
            </li>
            <li>
              <strong>Unit Testing and Project Management:</strong> Proficient
              in unit testing with Jest, and experience with project management
              and issue tracking tools like Jira and Trello, ensuring quality
              and timely delivery of projects.
            </li>
            <li>
              <strong>Agile Methodology:</strong> Knowledgeable in Agile
              Software Development Life Cycle (SDLC), with experience working in
              Agile teams, ensuring iterative and collaborative development
              processes.
            </li>
            <li>
              <strong>Fundamentals of Programming:</strong> Solid understanding
              and practical implementation of programming concepts including
              object-oriented programming (OOP), loops, conditional statements,
              functions, and exception handling.
            </li>
            <li>
              <strong>Additional Language Proficiency:</strong> Experience
              working with other languages like Java, Angular.js, Android, and
              C++, expanding the scope of development capabilities.
            </li>
            <li>
              <strong>Communication and Teamwork:</strong> Strong written and
              spoken communication skills, excellent team player,
              self-motivated, and eager to learn modern technologies,
              contributing to a positive and collaborative work environment.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
